// extracted by mini-css-extract-plugin
export var table = "_u1-0";